module.exports = __webpack_public_path__ + "static/ruexpress-50ecf199599dc50ecd097be183a7b740.png";